import { Box, CardMedia, List, ListItemText, Typography } from "@mui/material";
import FrameGlassCard from "components/views/frame_glass_card";
import { FrameGlassType } from "utils/other/enums";
import { dateFormatter } from "utils/other/services";

export default function ExperienceCard({ data }) {
  return (
    <FrameGlassCard
      type={FrameGlassType.Doff}
      borderRadius="20px"
      outline="6px solid rgba(255, 255, 255, 0.15)"
    >
      <Box
        sx={{
          display: "flex",
          alignItems: { xs: "center", sm: "flex-start" },
          flexDirection: { xs: "column", sm: "row" },
          gap: 2,
          padding: 2,
        }}
      >
        <Box
          sx={{
            width: { xs: 100, sm: 50 },
            height: { xs: 100, sm: 50 },
            borderRadius: { xs: 100, sm: 50 },
            backgroundColor: "white",
            filter: "drop-shadow(0px 4px 10px rgba(0, 0, 0, 0.10))",
            padding: 1.2,
            boxSizing: "border-box",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
          }}
        >
          <CardMedia
            component="img"
            src={data.company_image}
            height="auto"
            width="auto"
          />
        </Box>

        <Box sx={{ paddingTop: 1, flex: 1 }}>
          <Typography
            variant="h4"
            sx={{
              fontFamily: "Poppins",
              fontWeight: 500,
              fontSize: { xs: 16, sm: 18 },
            }}
          >
            {data.position}
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              justifyContent: "space-between",
              alignItems: { xs: "flex-start", sm: "center" },
            }}
          >
            <Typography
              variant="h4"
              sx={{
                fontFamily: "Poppins",
                fontWeight: 400,
                fontSize: { xs: 12, sm: 14 },
                color: "rgba(0,0,0,0.8)",
              }}
            >
              {data.company_name} - {data.type}
            </Typography>
            <Typography
              variant="h4"
              sx={{
                fontFamily: "Poppins",
                fontWeight: 400,
                fontSize: { xs: 12, sm: 14 },
                color: "rgba(0,0,0,0.6)",
                textAlign: "right",
              }}
            >
              {`${dateFormatter(data.start_at, "MMMM yyyy")} - ${
                data.end_at
                  ? dateFormatter(data.end_at, "MMMM yyyy")
                  : "Sekarang"
              }`}
            </Typography>
          </Box>
          <Box height={15} />
          <Typography
            variant="h4"
            sx={{
              fontFamily: "Poppins",
              fontWeight: 400,
              fontSize: { xs: 12, sm: 14 },
              color: "black",
            }}
          >
            Deskripsi Pekerjaan :
          </Typography>
          <List
            component="ul"
            sx={{
              listStyleType: "disc",
              padding: "0 0 0 20px",
              margin: 0,
            }}
          >
            {data.descriptions.map((_, __) => (
              <ListItemText
                key={__}
                primary={_}
                primaryTypographyProps={{
                  fontFamily: "Poppins",
                  fontWeight: 400,
                  fontSize: { xs: 12, sm: 14 },
                  color: "black",
                }}
                sx={{
                  display: "list-item",
                }}
              />
            ))}
          </List>
          <Box height={15} />
          <Typography
            variant="h4"
            sx={{
              fontFamily: "Poppins",
              fontWeight: 400,
              fontSize: { xs: 12, sm: 14 },
              color: "black",
              marginBottom: 1.5,
            }}
          >
            Teknologi Yang Digunakan :
          </Typography>
          <List
            component="ul"
            sx={{
              listStyleType: "disc",
              padding: "0 0 0 20px",
              margin: 0,
            }}
          >
            <ListItemText
              primary={data.technologies.join(", ")}
              primaryTypographyProps={{
                fontFamily: "Poppins",
                fontWeight: 400,
                fontSize: { xs: 12, sm: 14 },
                color: "black",
              }}
              sx={{
                display: "list-item",
                marginTop: -1,
              }}
            />
          </List>
        </Box>
      </Box>
    </FrameGlassCard>
  );
}
